




























































































































































































import { auth } from "@/scripts/firebase";
//import { is } from 'vee-validate/dist/rules';
//import { maritoUser } from "@/scripts/datatypes";
import Vue from "vue";
import { Component,Watch} from "vue-property-decorator";

@Component

/**
 * router-link-exact-active 要素に is-active 加える
 * 上記の要素の親 .navbar-dropdown は none にしない
 * もうすこし色々工夫する
 */

export default class Header extends Vue {
  isActive = [false,false,false,false,false,false]

  inActive(exclude = -1){
    this.isActive.forEach((isActive: boolean,index: number) =>{
      if(isActive && exclude !== index){
        this.$set(this.isActive,index,false)
      }
    })
  }

  async created(){
    //window.addEventListener('scroll', this.inActive)
    window.addEventListener('resize', () =>{this.inActive()})

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      if(! target.closest('nav.navbar')){
        this.inActive()
      }
    },false);
  }

  get signIn(): boolean {
    return !!(this.$store.getters.schoolId && this.$store.getters.uid)
  }

  get isSuperAdmin(): boolean {
    return 10 <= this.$store.getters.accessLevel && this.$store.getters.disabled === false
  }

  get isStaff(): boolean {
    return 5 <= this.$store.getters.accessLevel && this.$store.getters.disabled === false
  }

  get isPublic(): boolean{
    return !! this.$route.meta.public
  }

  get schoolName(): string {
    return this.$store.getters.schoolName
  }

  @Watch('routePath') setStatus(){
    this.inActive()
  }

  get routePath(): string {
    return this.$route.path
  }

  toggleActive(target: number){
    if(this.isActive[target]){
      this.$set(this.isActive,target,false)
    }else{
      this.inActive(0)
      this.$set(this.isActive,target,true)
    }
  }
   

  handleSignOut() {
    auth.signOut();
    this.inActive()
  }

}
